import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { handleNo, handleYes } from './eirCustomerCheck.util';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const EirCustomerCheckModal = ({ openAccountCheck, setEnableModal, setPrequaledFromBanner }) => {
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'MW-eirMobile_customer_check',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={openAccountCheck.value}
      handleClose={openAccountCheck.disable}
      desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url}`}
      mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url}`}
      desktopImageAlt={
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
      }
      mobileImageAlt={cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText}
      desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url}`}
      mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url}`}
      desktopCurveImgAlt='desktopCurve'
      mobileCurverImgAlt='mobileCurve'
      title={cmsCollectionData?.attributes?.title}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `} // will remove hardcoded discount once to get to know where to get data
      cta={[
        {
          // text: 'Login',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Login',
          type: 'contained',
          action: () => handleYes(openAccountCheck, setEnableModal, setPrequaledFromBanner),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
        {
          // text: 'Not an eir customer',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Not an eir customer',
          type: 'contained',
          action: () => handleNo(openAccountCheck),
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};

export default EirCustomerCheckModal;
